"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collectStyleParams = void 0;
var _DOM = require("../../../Utils/DOM");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getTextContentWithoutChildren = function getTextContentWithoutChildren(element) {
  var callback = function callback(a, b) {
    return a + (b.nodeType === Node.TEXT_NODE ? b.textContent : '');
  };
  return [].reduce.call(element.childNodes, callback, '') + '';
};
var hasElementTextContent = function hasElementTextContent(element) {
  return !!getTextContentWithoutChildren(element).replace(/ /g, '').length;
};
var storeFontParams = function storeFontParams(params, element) {
  var colorIdentifier = element.dataset.color;
  var style = element.style;
  params.fontSize = style.fontSize || params.fontSize;
  params.fontFamily = style.fontFamily || params.fontFamily;
  params.fontWeight = style.fontWeight || params.fontWeight;
  params.fontStyle = style.fontStyle || params.fontStyle;
  params.textAlign = style.textAlign || params.textAlign;
  if (colorIdentifier && hasElementTextContent(element)) {
    params.colors.push({
      identifier: colorIdentifier,
      value: style.color
    });
  }
};

// set the initial values that are not there automatically
var initialParamValues = {
  fontWeight: 'normal',
  fontStyle: 'normal',
  textAlign: 'left'
};
var collectStyleParams = exports.collectStyleParams = function collectStyleParams(content) {
  var div = document.createElement('div');
  div.innerHTML = content;
  var params = _objectSpread({
    colors: []
  }, initialParamValues);
  (0, _DOM.traverse)(div, function (item) {
    if (item.nodeType === Node.ELEMENT_NODE) {
      storeFontParams(params, item);
    }
  });
  return params;
};